export interface FastNavPresetOptions {
  hideEdges: boolean;
  hideSAO: boolean;
  hidePBR: boolean;
  hideColorTexture: boolean;
  hideTransparentObjects: boolean;
  scaleCanvasResolution: boolean;
  scaleCanvasResolutionFactor: number;
  delayBeforeRestore: boolean;
  delayBeforeRestoreSeconds: number;
  selectedIfcTypes: 'show' | 'hide';
  filterIfcTypes: string[];
}

export const ifcTypesListInit = [
  'IfcFurniture',
  'IfcFurnishingElement',
  'IfcDiscreteAccessory',
  'IfcMechanicalFastener',
  'IfcShadingDevice',
  'IfcAirTerminal',
  'IfcFlowTerminal',
  'IfcFlowFitting',
  'IfcFlowController',
  'IfcFlowSegment',
  'IfcFlowMovingDevice',
  'IfcBuildingElementProxy',
  'IfcCovering',
  'IfcDistributionElement',
  'IfcDistributionFlowElement',
  'IfcDistributionControlElement',
  'IfcEnergyConversionDevice',
];

export const fastNavPresets: { [key: string]: FastNavPresetOptions } = {
  none: {
    hideEdges: true,
    hideSAO: true,
    hidePBR: true,
    hideColorTexture: true,
    hideTransparentObjects: true,
    scaleCanvasResolution: false,
    scaleCanvasResolutionFactor: 0,
    delayBeforeRestore: false,
    delayBeforeRestoreSeconds: 0,
    selectedIfcTypes: 'show',
    filterIfcTypes: [],
  },

  low: {
    hideEdges: true,
    hideSAO: true,
    hidePBR: true,
    hideColorTexture: true,
    hideTransparentObjects: true,
    scaleCanvasResolution: true,
    scaleCanvasResolutionFactor: 0.75,
    delayBeforeRestore: true,
    delayBeforeRestoreSeconds: 0.7,
    selectedIfcTypes: 'hide',
    filterIfcTypes: [
      'IfcFurniture',
      'IfcFurnishingElement',
      'IfcDiscreteAccessory',
      'IfcMechanicalFastener',
      'IfcShadingDevice',
      'IfcAirTerminal',
      'IfcFlowTerminal',
      'IfcFlowFitting',
      'IfcFlowController',
    ],
  },

  high: {
    hideEdges: true,
    hideSAO: true,
    hidePBR: true,
    hideColorTexture: true,
    hideTransparentObjects: true,
    scaleCanvasResolution: true,
    scaleCanvasResolutionFactor: 0.3,
    delayBeforeRestore: true,
    delayBeforeRestoreSeconds: 2,
    selectedIfcTypes: 'hide',
    filterIfcTypes: [
      'IfcFurniture',
      'IfcFurnishingElement',
      'IfcDiscreteAccessory',
      'IfcMechanicalFastener',
      'IfcShadingDevice',
      'IfcAirTerminal',
      'IfcFlowTerminal',
      'IfcFlowFitting',
      'IfcFlowController',
      'IfcFlowSegment',
      'IfcFlowMovingDevice',
      'IfcBuildingElementProxy',
      'IfcCovering',
      'IfcDistributionElement',
      'IfcDistributionFlowElement',
      'IfcDistributionControlElement',
      'IfcEnergyConversionDevice',
    ],
  },
};

export const fastNavPresetList = [...Object.keys(fastNavPresets), 'custom'];
